export const RESET_ERROR = 'vehicle/RESET_ERROR';

export const FETCH_CONFIRMATION_NEW_SUCCESS = 'vehicle/FETCH_CONFIRMATION_NEW_SUCCESS';
export const FETCH_CONFIRMATION_NEW_FAIL = 'vehicle/FETCH_CONFIRMATION_NEW_FAIL';
export const FETCH_CONFIRMATION_DELETED_SUCCESS = 'vehicle/FETCH_CONFIRMATION_DELETED_SUCCESS';
export const FETCH_CONFIRMATION_DELETED_FAIL = 'vehicle/FETCH_CONFIRMATION_DELETED_FAIL';
export const FETCH_CONFIRMATION_CHANGED_SUCCESS = 'vehicle/FETCH_CONFIRMATION_CHANGED_SUCCESS';
export const FETCH_CONFIRMATION_CHANGED_FAIL = 'vehicle/FETCH_CONFIRMATION_CHANGED_FAIL';

export const COPY_CONFIRMATION_SUCCESS = 'vehicle/COPY_CONFIRMATION_SUCCESS';
export const COPY_CONFIRMATION_FAIL = 'vehicle/COPY_CONFIRMATION_FAIL';
